import { Search } from '~/types/search'
import { ApiKy } from './index'

export default class Api extends ApiKy {
  search(q: string) {
    return this.ky
      .get(`${this.url}`, {
        searchParams: { q },
      })
      .json<Search[]>()
  }
}
